import { getDeployment } from 'utils/deployment';

const deployment = getDeployment();

/**
 * Declare here all the routes
 * that is not belong to menu
 */
const learners = {
    id: 'learners',
    url: '/learners',
    permissions: {
        resource: `arn:tlrg:lln-robot::${deployment}:learners/1`
    }
};

export default [learners];
